import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import BlockProjectNotifPageUI from './BlockProjectNotifPageUI.js'

class BlockProjectNotifPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      projectNotFound: false,
      projectName: null,
      accountId: null,
      accountName: null,
      submitted: false,
    }
  }

  render() {
    return (
      <BlockProjectNotifPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        projectNotFound={this.state.projectNotFound}
        projectName={this.state.projectName}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        onCancel={this.onCancel}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProjectPub(context)
  }

  onSubmit = (event) => {
    if (this.state.submitted)
      return

    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      `/api/pub/projects/${this.props.match.params.projectId}/users/${this.props.match.params.encryptedUserId}/emailAcceptance`,
      this.onSubmitCallback, {
        emailAcceptance: 'block',
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({submitted: false, errorList: errorList, successMsg: response.success})

    if (errorList.length === 0) {
      setTimeout(() => {
        window.location = '/'
      }, 3000);
    }
  }

  onCancel = (event) => {
    window.location = '/'
  }

  getProjectPub(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/projects/${this.props.match.params.projectId}`,
      cacheKey: CacheKeys.ProjectPub(this.props.match.params.projectId),
      callback: this.getProjectPubCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectPubCallback = (response) => {
    let context = this.props.context
    if (response.errorList.length > 0) {
      this.setState({
        projectNotFound: true
      })
    }

    this.setState({
      projectName: response.projectName,
      accountId: response.accountId,
      accountName: response.accountName
    })

    this.getMessages(context)
  }

  getMessages(context) {
    let arr = [
      'c_opt_out_prj_email_q',
      'c_opt_out_prj_email_d',
      'c_prj_email_optin_hint',
      'c_opt_out',
      'c_cancel',
      'c_continue',
      'c_not_found'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_blk_prj_eml', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
    // cannot check session because user id was encrypted in URL
    // this.checkSession()
  }

  /*
  // if user id not matching, logout the user
  checkSession() {
    let context = this.props.context
    let userIdsession = context.session.userId
    let userIdParam = this.props.match.params.userId
    if (userIdsession && userIdsession !== userIdParam) {
      sessions.delete(context, this.deleteSessionCallback)
    }
  }

  deleteSessionCallback = (response) => {
    let context = this.props.context
    localStorage.removeItem(LocalStorageKeys.Session)
    localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
    let sessionHelper = new SessionHelper(context)
    sessionHelper.getSession()
  }
  */

}

export default withRouter(BlockProjectNotifPageSF)
